<template>
    <div>
        <Modal v-model="showStudentsModal" title="上课学员清单"  width="800">
            <Table :columns="studentsColumns" :data="studentsData">
                <template slot-scope="{ row, index }" slot="state">
                    <div v-if="row.state==1">未开始</div>
                    <div v-else-if="row.state==2"><Tag color="success">已结束</Tag></div>
                    <div v-else-if="row.state==3"><Tag color="warning">已取消</Tag><br>{{row.reason}}</div>
                    <div v-else>异常</div>
                </template>
                <template slot-scope="{ row, index }" slot="op">
                    <Button type="primary" size="small" @click="cancelClass(row.id)" v-if="row.state==1" style="margin-right: 5px;">取消</Button>
                </template>
            </Table>
            <div slot="footer"></div>
        </Modal>
        <cancelWin ref="cancelWin" @on-cancel-success="onCancelSuccess" :mode="2"></cancelWin>

    </div>
</template>

<script>
  import cancelWin from '../schedule/cancelWin'

  export default {
    name: 'clazz_schedule',
    components: {
      cancelWin
    },
    props: {
      clazzId: Number
    },
    data() {
      return {
        classRecordId:null,
        showStudentsModal:false,
        studentsColumns:[
          {
            title:'姓名',
            key:'name',
            align:'center'
          },
          {
            title:'状态',
            align:'center',
            slot:'state'
          },
          {
            title:'操作',
            align:'center',
            slot:'op'
          },
        ],
        studentsData:[],
      }
    },
    methods: {
      showModal:function(classRecordId){
        this.classRecordId = classRecordId;
        this.getList();
        this.showStudentsModal = true;
      },
      getList:function(){
        this.studentsData = [];
        this.$api.clazz.getClassLogStudentList({recordId:this.classRecordId}).then(res => {
          if (res.state == "ok") {
            this.studentsData = res.data;
            this.showStudentsModal = true;
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      cancelClass:function(id){
        this.$refs.cancelWin.showCancelWin(id);
      },
      onCancelSuccess(){
        this.getList();
        this.$emit('onchange');
      }
    },
    filters:{
    },
  }
</script>
